module.exports = __webpack_public_path__ + "img/ad5.e6392a22.png";